exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cover[data-v-08d27332] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 400ms;\n  z-index: 100;\n}\n.cover.active[data-v-08d27332] {\n  opacity: 1;\n  pointer-events: all;\n  transition: all 400ms;\n}", ""]);

// exports
